<template>
  <div class="inner-container">
    <ul class="list">
      <li class="list__item">
        <label for>Spatial Filter</label>
        <vs-switch
          v-model="spatialFilter"
          color="#19535F"
          :disabled="block"
          @change="onFilterChange"
        />
      </li>
    </ul>
    <coordinates-inputs
      v-if="spatialFilter"
      :point="marker"
      @coords-updated="setScToolPoint"
    />
  </div>
</template>
<script>
import SpatialFilterControlCoordsInputs from "@/components/ui/SpatialFilterControlCoordsInputs";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    "coordinates-inputs": SpatialFilterControlCoordsInputs
  },
  props: {
    forceActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      spatialFilter: false,
      block: false
    };
  },
  computed: {
    ...mapState("map", {
      marker: state => state.marker
    })
  },
  mounted() {
    if (this.forceActive) {
      this.spatialFilter = true;
      this.block = true;
    }
  },
  methods: {
    ...mapActions("map", {
      setScToolPoint: "setScToolPoint"
    }),
    onFilterChange() {
      this.$emit("onFilterChange", this.spatialFilter);
    }
  }
};
</script>
<style lang="scss" scoped>
.inner-container {
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
  padding: 0.5rem;
  align-items: center;
}
.list {
  display: flex;
  margin-left: 50px;
  &__item {
    display: flex;
    list-style: none;
  }
  & label {
    margin-right: 1rem;
    align-self: center;
  }
}
</style>
